import { ScheduleViewScreenlistItemComponent } from './../../components/schedule-view/schedule-view-screenlist-item/schedule-view-screenlist-item.component';
import { NouisliderModule } from 'ng2-nouislider';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ScheduleViewComponent } from './../../components/schedule-view/schedule-view.component';
import { SortablejsModule } from 'angular-sortablejs';
import { AddscreenDialogComponent } from './../../../backend-main.module/pages/scheduling/components/addscreen-dialog/addscreen-dialog.component';
import { ScreenorderDialogComponent } from './../../../backend-main.module/pages/scheduling/components/screenorder-dialog/screenorder-dialog.component';
import { RouterModule } from '@angular/router';
import { RotationitemListitemComponent } from './../../../backend-main.module/pages/scheduling/components/rotationitem-listitem/rotationitem-listitem.component';
import { ScreenPanelComponent } from './../../../backend-main.module/pages/designer.module/components/screen-panel/screen-panel.component';
import { MomentModule } from 'ngx-moment';
import { NgPipesModule } from 'ngx-pipes';
import { CheckboxModule, RadioButtonModule, SpinnerModule, TooltipModule, InplaceModule, DropdownModule, CalendarModule, MultiSelectModule, TreeTableModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../../../core.module/core.module';
import {
  TimeframeItemComponent,
} from '../../../backend-main.module/pages/scheduling/components/timeframe-item/timeframe-item.component';
import {
  TimelineDialogComponent,
} from '../../../backend-main.module/pages/scheduling/components/timeline-dialog/timeline-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerDownloadComponent } from '../../../player-download/player-download.component';
import { AccordionModule } from 'primeng/accordion';
import { EditConditionDialogComponent } from '../../../backend-main.module/pages/scheduling/components/editconditions-dialog/editconditions-dialog.component';
import { ViewContainerComponent } from '../../../player/components/view-container/view-container.component';


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    DropdownModule,
    RadioButtonModule,
    SpinnerModule,
    TooltipModule,
    NgPipesModule,
    MomentModule,
    InplaceModule,
    RouterModule,
    SortablejsModule.forRoot({}),
    MultiSelectModule,
    AccordionModule,
    SelectButtonModule,
    TreeTableModule,
    NouisliderModule
  ],
  declarations: [
    TimelineDialogComponent,
    TimeframeItemComponent,
    ScreenPanelComponent,
    RotationitemListitemComponent,
    AddscreenDialogComponent,
    ScreenorderDialogComponent,
    PlayerDownloadComponent,
    EditConditionDialogComponent,
    ViewContainerComponent,
    ScheduleViewComponent,
    ScheduleViewScreenlistItemComponent
  ],
  exports: [
    TimelineDialogComponent,
    TimeframeItemComponent,
    ScreenPanelComponent,
    AddscreenDialogComponent,
    ScreenorderDialogComponent,
    RotationitemListitemComponent,
    SortablejsModule,
    AccordionModule,
    EditConditionDialogComponent,
    ViewContainerComponent,
    ScheduleViewComponent,
    SpinnerModule
  ],
  entryComponents: [
    ScreenPanelComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module/shared.module.ts